module.exports = __webpack_public_path__ + "media/images/template-021b79dbb2f5cc55e2972b2936532a83.svg";